module.exports = __webpack_public_path__ + "static/media/CNews1.4b22879c.png";